import React from "react";
import { Shield, Star, Award, ExternalLink } from "lucide-react";

export const TrustBadges = () => {
  return (
    <section 
      data-testid="trust-badges-section"
      className="bg-gradient-to-r from-teal-50 via-white to-orange-50 border-b border-gray-200 py-3"
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12">
          {/* CQC Rating Badge */}
          <a
            href="https://www.cqc.org.uk/location/1-111147708"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cqc-rating-badge"
            className="flex items-center gap-3 bg-white px-4 py-2 rounded-full shadow-md border border-teal-100 hover:shadow-lg hover:border-teal-300 transition-all group"
          >
            <div className="flex items-center justify-center w-10 h-10 bg-teal-600 rounded-full">
              <Shield className="h-5 w-5 text-white" />
            </div>
            <div className="text-left">
              <div className="text-xs text-gray-500 font-medium uppercase tracking-wide">CQC Rating</div>
              <div className="flex items-center gap-2">
                <span className="text-lg font-bold text-teal-700">Good</span>
                <ExternalLink className="h-3 w-3 text-gray-400 group-hover:text-teal-600 transition-colors" />
              </div>
            </div>
          </a>

          {/* Carehome.co.uk Rating Badge */}
          <a
            href="https://www.carehome.co.uk/carehome.cfm/searchazref/20003515BARB"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="carehome-rating-badge"
            className="flex items-center gap-3 bg-white px-4 py-2 rounded-full shadow-md border border-orange-100 hover:shadow-lg hover:border-orange-300 transition-all group"
          >
            <div className="flex items-center justify-center w-10 h-10 bg-orange-500 rounded-full">
              <Star className="h-5 w-5 text-white fill-white" />
            </div>
            <div className="text-left">
              <div className="text-xs text-gray-500 font-medium uppercase tracking-wide">carehome.co.uk</div>
              <div className="flex items-center gap-2">
                <span className="text-lg font-bold text-orange-600">9.5</span>
                <span className="text-sm text-gray-500">/10</span>
                <div className="flex items-center gap-0.5 ml-1">
                  {[...Array(5)].map((_, i) => (
                    <Star 
                      key={i} 
                      className="h-3 w-3 text-orange-400 fill-orange-400" 
                    />
                  ))}
                </div>
                <ExternalLink className="h-3 w-3 text-gray-400 group-hover:text-orange-600 transition-colors" />
              </div>
            </div>
          </a>

          {/* Trust Indicator */}
          <div 
            data-testid="trust-indicator"
            className="hidden lg:flex items-center gap-2 text-gray-600"
          >
            <Award className="h-5 w-5 text-teal-600" />
            <span className="text-sm font-medium">Trusted by Families Across Wirral</span>
          </div>
        </div>
      </div>
    </section>
  );
};
